define('models/t1AppDevTeam',["Underscore", "T1", "T1Model", "T1Comm"], function (_, T1, T1Model, T1Comm) {
  "use strict";

  T1.Models.T1AppsDevTeam = T1Model.extend({
    apiRoot: T1.API_APPS_ROOT,
    dataType: "json",
    url: "",
    fetch: function (options) {
      var self = this;
      return T1Comm.get({
        dataType: "json",
        errorDisplaySuppressingConfig: {
          errorSuppressed: true,
          errorCodes: [404]
        },
        processAjaxResponse: self.processAjaxResponse,
        onStatusInvalid: function () {
          T1.Location.set("#appstore");
        },
        onSuccess: options.success,
        onError: function () {
          T1.Location.set("#appstore");
        },
        sourceURL: T1.API_APPS_ROOT + "v1.0/apps/" + options.appID + "/dev-team"
      });
    },
    processAjaxResponse: function (resp) {
      return {
        jsonData: resp,
        statusCode: "ok"
      };
    }
  });
  return T1.Models.T1AppsDevTeam;
});
